enum TaxNoticeMatchOrgStatus {
  FAIL_USER = -200, // 사용자가 발송처 정보를 변경했음에도 연락처 정보를 찾을 수 없음

  FAIL_SYSTEM = -100, // OCR로 추출한 기관명으로 연락처 정보를 찾았으나 찾을 수 없음

  READY = 0, // 연락처 정보를 찾기 전(대기 상태)

  SYSTEM = 100, // 연락처 정보를 자동으로 찾음

  USER = 200, // 연락처 정보를 사용자가 수동으로 입력함
}

export default TaxNoticeMatchOrgStatus;
